import React from 'react';

const FilterChips = ({ chips, onRemove, onClearAll, onUndo, canUndo }) => {
  const getStateIcon = (state) => {
    switch (state) {
      case 'include': return '✓';
      case 'exclude': return '✗';
      case 'only': return '★';
      default: return '○';
    }
  };

  const getStateClass = (state) => {
    switch (state) {
      case 'include': return 'chip--include';
      case 'exclude': return 'chip--exclude';
      case 'only': return 'chip--only';
      default: return '';
    }
  };

  const getStateLabel = (state) => {
    switch (state) {
      case 'include': return 'Include';
      case 'exclude': return 'Exclude';
      case 'only': return 'Only';
      default: return 'Off';
    }
  };

  if (Object.keys(chips).length === 0) {
    return (
      <div className="chips-row chips-row--empty">
        <p>No layer filters applied</p>
      </div>
    );
  }

  return (
    <div className="chips-row">
      <div className="chips-header">
        <h4 className="chips-title">Active Filters</h4>
        <div className="chips-actions">
          {canUndo && (
            <button className="chips-btn chips-btn--undo" onClick={onUndo}>
              ↩️ Undo
            </button>
          )}
          <button className="chips-btn chips-btn--clear" onClick={onClearAll}>
            🗑️ Clear All
          </button>
        </div>
      </div>
      
      <div className="chips-container">
        {Object.entries(chips).map(([layerKey, variants]) => {
          if (!variants || Object.keys(variants).length === 0) return null;
          
          return Object.entries(variants).map(([variantId, state]) => {
            if (!state) return null;
            
            return (
              <div
                key={`${layerKey}-${variantId}`}
                className={`filter-chip ${getStateClass(state)}`}
              >
                                 <div className="chip-thumbnail">
                   <img
                     src={`data:image/svg+xml;base64,${btoa(`
                       <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                         <rect width="24" height="24" fill="#333"/>
                         <text x="12" y="12" font-family="Arial" font-size="8" fill="#fff" text-anchor="middle" dy=".3em">${variantId}</text>
                       </svg>
                     `)}`}
                     alt={`${layerKey} ${variantId}`}
                     className="chip-image"
                   />
                 </div>
                <div className="chip-info">
                  <span className="chip-layer">{layerKey}</span>
                  <span className="chip-variant">#{variantId}</span>
                  <span className="chip-state">{getStateLabel(state)}</span>
                </div>
                <button
                  className="chip-remove"
                  onClick={() => onRemove(layerKey, variantId)}
                  title="Remove filter"
                >
                  ×
                </button>
                <div className="chip-icon">{getStateIcon(state)}</div>
              </div>
            );
          });
        })}
      </div>
    </div>
  );
};

export default FilterChips;
